import client from "../utils/client";

export const contact = (data: ContactData): Promise<{ message: string }> =>
  client.post("/contact", data);
